module.exports = __webpack_public_path__ + "img/automated-test.202517ca.svg";